import React, { useRef, useState } from "react"
import { Form, Button, Card, Alert } from "react-bootstrap"
import { useAuth } from "../../contexts/AuthContext"
import { Link, useHistory } from "react-router-dom"
import CenteredContainer from "./CenteredContainer"

export default function Login() {
  const emailRef = useRef()
  const passwordRef = useRef()
  const { login } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setError("")
      setLoading(true)
      await login(emailRef.current.value, passwordRef.current.value)
      history.push("/")
    } catch {
      setError("Failed to log in")
    }

    setLoading(false)
  }

  return (<div>

    <CenteredContainer>
      <center> <img src="/images/jainim.png" style={{ "height": "200px", "width": "300px", "marginBottom": "30px" }}></img></center>

      <Card style={{ "padding": " 0 20px 0 20px", "borderRadius": "25px" }}>
        <Card.Body>

          {error && <Alert variant="danger">{error}</Alert>}
          <center><b style={{ "fontFamily": "-webkit-pictograph" }}>Sign in to Jainim Consulting collaboration site to continue</b></center>

          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" ref={emailRef} required />
            </Form.Group>
            <Form.Group id="password">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" ref={passwordRef} required />
            </Form.Group>
            <Button disabled={loading} className="w-100" type="submit">
              Log In
            </Button>
          </Form>
          {/*<div className="w-100 text-center mt-3">
            <Link to="/forgot-password">Forgot Password?</Link>
  </div> */}
        </Card.Body>
      </Card>
      <div className="w-100 text-center mt-2">
        <center> Need an account? Contact<span style={{ "color": "#007bff" }}>&nbsp;help@jainim.ca</span></center>
      </div>
    </CenteredContainer>
  </div>
  )
}
